import React, { useState } from 'react';
import { Button, Flex, Layout ,Menu} from 'antd';

import { Header,Content,Footer } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import { useNavigate } from 'react-router-dom';
import {Form} from 'antd';
import AppRoutes from './AdminLogin/AppRoutes';

const Main = (props) => {


  return(
    <AppRoutes  props={props}/>
  
)};
export default Main;

